"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Pdf = function Pdf(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.25 9.116a1.163 1.163 0 00-.556-.112h-.888a.24.24 0 00-.224.224v2.388c0 .14.112.252.252.252h.112c.14 0 .252-.112.252-.252v-.752h.472c.36 0 .612-.084.804-.252.192-.168.276-.388.276-.668a.952.952 0 00-.14-.5.826.826 0 00-.36-.328zm-.164 1.168c-.084.084-.196.112-.36.112h-.528v-.888h.556c.14 0 .252.056.332.14.084.084.112.196.112.332s-.028.22-.112.304zM10.725 9.172a1.315 1.315 0 00-.668-.168h-.612a.251.251 0 00-.252.252v2.364c0 .14.084.252.224.196h.64c.252 0 .444-.056.668-.168.224-.112.36-.276.472-.472.112-.196.168-.416.168-.696v-.14c0-.252-.056-.5-.168-.696a1.302 1.302 0 00-.472-.472zm.056 1.36c0 .28-.084.5-.196.64s-.304.224-.528.224h-.276V9.508h.304c.224 0 .416.056.528.224.112.168.168.388.168.668v.132zM13.421 9.004h-1.388a.251.251 0 00-.252.252v2.388a.22.22 0 00.224.224h.14a.22.22 0 00.224-.224V10.7h.916a.22.22 0 00.224-.224v-.028a.24.24 0 00-.224-.224h-.916V9.5h1.056a.22.22 0 00.224-.224V9.22c-.008-.104-.12-.216-.228-.216z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.117 3.36H5.929A1.63 1.63 0 004.3 4.988v10.028a1.63 1.63 0 001.628 1.628h8.144a1.63 1.63 0 001.628-1.628V7.94a4.588 4.588 0 00-4.584-4.58zm3.444 3.276h-1.176a.49.49 0 01-.488-.488V4.724a3.71 3.71 0 011.664 1.912zm.252 8.38a.737.737 0 01-.736.736H5.929a.737.737 0 01-.736-.736V4.984c0-.408.332-.736.736-.736h5.188c.308 0 .604.048.892.12v1.784c0 .76.616 1.376 1.376 1.376h1.384c.016.136.04.272.04.416v7.072h.004z",
    fill: color
  }));
};
var _default = exports["default"] = Pdf;